// BR builder
import { weekendMarkCaculate, isSmallScreenMobile } from './utils.js'
import { getBDLocale } from '@/common/utils/i18n'

export function LegendBuilder(data = [], options = {}) {
  return {
    bottom: 0,
    height: 8,
    itemWidth: 8,
    itemHeight: 8,
    textStyle: {
      color: '#666',
      fontSize: 12,
      lineHeight: 8,
      fontFamily: 'DiDiSans-Pro-Regular',
    },
    itemGap: 10,
    selectedMode: true,
    ...options,
    data,
  }
}

export function ToolTipBuilder(options = {}) {
  return {
    show: true,
    enterable: false,
    trigger: 'axis',
    axisPointer: {
      type: 'shadow',
    },
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    textStyle: {
      color: '#fff',
      fontSize: 12,
      fontFamily: 'DiDiSans-Pro-Regular',
      fontWeight: 400,
    },
    extraCssText: `width: calc(100% - 12px); word-wrap: break-word; overflow-wrap:break-word; white-space:normal; text-align:left`,
    position: function (point, params, dom, rect, size) {
      return [0, -30]
    },
    formatter: function (params) {
      let str = ``
      for (const item of params) {
        const { marker, seriesName, value } = item
        str = `${str}${marker}${seriesName}: ${value} `
      }
      return `${str}`
    },
    ...options,
  }
}

export function XAxisBuilder(options = {}) {
  return {
    type: 'category',
    axisLabel: {
      fontSize: 10,
      fontFamily: 'PingFangSC-Regular',
      color: '#8D9099',
      padding: [2, 0, 0, 0],
    },
    axisTick: {
      show: false,
    },
    axisLine: {
      lineStyle: {
        color: '#cccccc',
      },
    },
    ...options,
  }
}

export function YAxisBuilder(options = {}) {
  return {
    type: 'value',
    axisTick: {
      show: false,
    },
    axisLine: {
      show: false,
    },
    splitLine: {
      show: true,
      lineStyle: {
        type: 'dotted',
        dashOffset: 10,
      },
    },
    nameTextStyle: {
      color: '#8D9099',
      fontSize: 10,
    },
    axisLabel: {
      fontSize: 10,
      fontFamily: 'PingFangSC-Regular',
      color: '#8D9099',
    },
    ...options,
  }
}

export function WeekendBuilder(dateDate = [], dateToWeek = {}) {
  return {
    type: 'custom',
    zIndex: 0,
    silent: true,
    markArea: weekendMarkCaculate(dateDate, dateToWeek),
  }
}
// 为了解决翻译长度问题，需要调整图标的高度和距离底部的位置
export function getEchartHeightAndBottomByLocale(category) {
  const locale = getBDLocale()
  // br 配置 - 语言（葡语or英语）优化见下方localeConfig
  const BrazilCfg = {
    completeOrder: { height: 200, bottom: 65, heightHor: 180, bottomHor: 56 },
    promotionInvest: {
      height: isSmallScreenMobile() ? 220 : 190,
      bottom: 50,
      heightHor: isSmallScreenMobile() ? 145 : 180,
      bottomHor: isSmallScreenMobile() ? 55 : 55,
    },
    promotionPromo: {
      height: isSmallScreenMobile() ? 220 : 220,
      bottom: isSmallScreenMobile() ? 130 : 95,
      heightHor: isSmallScreenMobile() ? 145 : 180,
      bottomHor: isSmallScreenMobile() ? 68 : 65,
    },
    users: { height: 220, bottom: 55, heightHor: 140, bottomHor: isSmallScreenMobile() ? 45 : 65 }, // 用户通用
    usersAllUser: {
      height: 220,
      bottom: isSmallScreenMobile() ? 55 : 55,
      heightHor: 140,
      bottomHor: isSmallScreenMobile() ? 45 : 55,
    }, // 用户 - 全部用户
    usersPercentage: {
      height: 220,
      bottom: isSmallScreenMobile() ? 55 : 55,
      heightHor: 140,
      bottomHor: isSmallScreenMobile() ? 45 : 55,
    }, // 用户 - 比例
    serviceDuration: { height: 270, bottom: 75, bottomHor: 75 },
    serviceTimeout: { height: 220, bottom: 75, heightHor: 180, bottomHor: 65 },
    serviceCancel: { height: 270, bottom: 75, bottomHor: 75 },
    serviceQuestion: { height: 220, bottom: 75, bottomHor: 80 },
    // online: { height: 180, bottom: 56, heightHor: 200, bottomHor: 56 }, // 在线模块已作废
    usersAndConversion: {
      height: 220,
      bottom: 115,
      heightHor: isSmallScreenMobile() ? 160 : 180,
      bottomHor: isSmallScreenMobile() ? 35 : 45,
    },
  }
  const localeConfig = {
    'zh-CN': {
      ...BrazilCfg,
      promotionPromo: {
        // 投资&营销
        height: isSmallScreenMobile() ? 186 : 190,
        bottom: isSmallScreenMobile() ? 95 : 100,
        heightHor: isSmallScreenMobile() ? 140 : 160,
        bottomHor: isSmallScreenMobile() ? 68 : 65,
      },
    },
    'es-MX': {
      completeOrder: { height: 200, bottom: 65, heightHor: 180, bottomHor: 56 },
      promotion: { height: 220, bottom: 115, heightHor: 180, bottomHor: 65 },
      users: { height: 220, bottom: 115, heightHor: 180, bottomHor: 65 },
      serviceCancle: { height: 270, bottom: 95, bottomHor: 75 },
      serviceQuestion: { height: 220, bottom: 95, bottomHor: 75 },
      online: { height: 180, bottom: 56, heightHor: 200, bottomHor: 56 },
      usersAndConversion: { height: 220, bottom: 115, heightHor: 180, bottomHor: 65 },
    },
    'en-US': {
      ...BrazilCfg,
      // 英语优化：
      promotionPromo: {
        // 投资&营销
        height: isSmallScreenMobile() ? 186 : 190,
        bottom: isSmallScreenMobile() ? 130 : 112,
        heightHor: isSmallScreenMobile() ? 140 : 140,
        bottomHor: isSmallScreenMobile() ? 68 : 65,
      },
    },
    'pt-BR': {
      ...BrazilCfg,
      // 葡语优化：
      promotionPromo: {
        // 投资&营销
        height: isSmallScreenMobile() ? 186 : 190,
        bottom: isSmallScreenMobile() ? 130 : 112,
        heightHor: isSmallScreenMobile() ? 140 : 140,
        bottomHor: isSmallScreenMobile() ? 68 : 65,
      },
    },
  }
  return (localeConfig[locale] && localeConfig[locale][category]) || localeConfig['pt-BR'][category]
}

export const chartKeyForHorShow = [
  'completeOrder',
  'promotion',
  'service',
  'usersAndConversion',
  'users',
  'online',
]

export const normalRoleChartKeyForHorShow = [
  // 'completeOrder',
  'promotion',
  'service',
  // 'usersAndConversion',
  'users',
  'online',
]
